import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button/Button';
import { Container } from '../ui/Container/Container';
import { useAuthStore } from '../../stores/authStore';
import { UserMenu } from './UserMenu';

export function PublicHeader() {
  const { user } = useAuthStore();
  const fetchMe = useAuthStore(s => s.fetchMe);
  const attemptedHydration = React.useRef(false);

  React.useEffect(() => {
    if (attemptedHydration.current) return;
    attemptedHydration.current = true;
    if (!useAuthStore.getState().user) {
      // Check if user is logged in without redirecting on failure
      (async () => { 
        try { 
          await fetchMe(true); // skipRedirect = true for public pages
        } catch (e) {
          // Silent fail - user is not logged in, which is fine for public pages
        }
      })();
    }
  }, [fetchMe]);

  return (
    <header className="h-14 flex items-center justify-between border-b bg-background/80 backdrop-blur-sm">
      <Container size="lg" className="flex items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img 
              src="/images/logo_moniker_cockpit.png" 
              alt="Moniker Cockpit" 
              className="h-6 object-contain"
            />
          </Link>
        </div>
        {user ? (
          <div className="flex gap-4">
            <Link to="/dashboard">
              <Button variant="ghost" size="sm">Dashboard</Button>
            </Link>
            <Link to="/pricing">
              <Button variant="ghost" size="sm">Pricing</Button>
            </Link>
            <UserMenu />
          </div>
        ) : (
          <div className="flex gap-4">
            <Link to="/pricing">
              <Button variant="ghost" size="sm">Pricing</Button>
            </Link>
            <Link to="/auth">
              <Button variant="secondary" size="sm">Sign in</Button>
            </Link>
          </div>
        )}
      </Container>
    </header>
  );
}
